<div class="progress" style="height: 5px;">
    <div class="progress-bar" role="progressbar" [style.width]="progressBarWidth" [attr.aria-valuenow]="currentPage" aria-valuemin="0" [attr.aria-valuemax]="totalNumberOfPages"></div>
  </div>
  